export const TABLE_ROW_HEIGHT_GROUPED_STATUSES = 100;
export const TABLE_ROW_HEIGHT_SEPARATE_STATUSES = 120;
export const TABLE_ROW_HEIGHT = TABLE_ROW_HEIGHT_SEPARATE_STATUSES;
export const MINI_TABLE_ROW_HEIGHT = 64;
// Keep auto-row estimates aligned to the baseline row height to avoid pagination "jumps" when
// `getRowHeight={() => 'auto'}` rows are measured and their render zone is re-laid out.
export const TABLE_ROW_MEASURE_HEIGHT = TABLE_ROW_HEIGHT;
export const TABLE_ROW_HEIGHT_CSS_VAR = '--flowqa-table-row-height';
export const TABLE_ROW_HEIGHT_CSS_VALUE = `var(${TABLE_ROW_HEIGHT_CSS_VAR}, ${TABLE_ROW_HEIGHT}px)`;
export const TABLE_PANEL_HEADER_HEIGHT = 53;
export const TABLE_GRID_HEADER_HEIGHT = 45;
export const TABLE_PAGINATION_HEIGHT = 45;
// Keep shared table separators visually aligned with the surrounding frame borders.
export const TABLE_DIVIDER_WIDTH = 1;

export const resolveTableRowHeight = (groupErroredWithFailed: boolean): number =>
  groupErroredWithFailed ? TABLE_ROW_HEIGHT_GROUPED_STATUSES : TABLE_ROW_HEIGHT_SEPARATE_STATUSES;
